import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  LoadingController,
} from "ionic-angular";

import { ParticipacaoProvider } from "../../../providers/participacao/partipacao.provider";
import { ReciclagemProvider } from "../../../providers/reciclagem/reciclagem.provider";
import { ReciboProvider } from "../../../providers/reciclagem/recibo.provider";
import { CampanhaProvider } from "../../../providers/campanhas/campanha.provider";
import { AnonymizeProvider } from "../../../providers/anonymize/anonymize.provider";

import { ParticipacaoPage } from "../../participacao/participacao";

@IonicPage({
  name: "page-reciclagem-recibo",
  segment: "page-reciclagem-recibo/:id",
})
@Component({
  selector: "page-reciclagem-recibo",
  templateUrl: "reciclagem-recibo.html",
})
export class ReciclagemReciboPage {
  evento_aberto: any;
  reciclagem: any | false = false;
  campanhas: boolean | any = false;
  showCampanhas: boolean = false;
  notificacao = false;
  aplicativo = false;
  color = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public participacaoProvider: ParticipacaoProvider,
    public reciclagemProvider: ReciclagemProvider,
    public reciboProvider: ReciboProvider,
    public campanhaProvider: CampanhaProvider,
    public alertCtrl: AlertController,
    public loadCtrl: LoadingController,
    public toastCtrl: ToastController,
    public anonymizeProvider: AnonymizeProvider
  ) {
    this.getReciclagem(this.navParams.get("id"));
    this.notificacao = this.navParams.get("notificacao");
    this.aplicativo = this.navParams.get("aplicativo");

    if (!this.aplicativo) {
      this.color = "primary";
    } else if (this.aplicativo && !this.notificacao) {
      this.color = "danger";
    } else if (this.aplicativo && this.notificacao) {
      this.color = "secondary";
    }
  }

  enviarRecibo(tipo: string) {
    if (tipo === "EMAIL") this.promptEmail();
    if (tipo === "SMS") this.promptSMS();
  }

  goToParticipacao() {
    this.navCtrl.setRoot(ParticipacaoPage);
  }

  participarCampanha(campanha_id) {
    let reciclagem_id: number = this.reciclagem.id;
    let contrato_id: number = this.reciclagem.participacao.contrato_id;

    this.campanhaProvider
      .participar(contrato_id, campanha_id, reciclagem_id)
      .then((success: any) => {
        this.alertInfo("Participação realizada!");
        this.showCampanhas = false;
      });
  }

  /* Privates */
  private getReciclagem(reciclagem_id) {
    let load = this.loadCtrl.create({ content: "Buscando reciclagem..." });
    load.present();

    this.reciclagemProvider.getById(reciclagem_id).subscribe((reciclagem) => {
      this.reciclagem = reciclagem;
      this.getCampanhasAtivas();

      load.dismiss();
    });
  }

  private promptEmail() {
    let alert = this.alertCtrl.create({
      title: "Recibo via E-mail",
      inputs: [
        {
          name: "email",
          placeholder: "email@provedor.com",
          value: this.reciclagem.participacao.cliente.email,
        },
      ],
      buttons: [
        {
          text: "Desistir",
          role: "cancel",
        },
        {
          text: "ENVIAR",
          handler: (data) => {
            (async () => {
              if (data.email !== "") {
                let load = this.loadCtrl.create({
                  content: "Enviando E-mail...",
                });
                load.present();
                try {
                  await this.reciboProvider.enviarEmail(
                    this.reciclagem,
                    data.email
                  );

                  load.dismiss();
                  let toast = this.toastCtrl.create({ duration: 1500 });
                  toast.setMessage("Email Enviado com Sucesso!");
                  toast.present();
                } catch (error) {
                  load.dismiss();
                  let toast = this.toastCtrl.create({ duration: 1500 });
                  toast.setMessage("Houve um erro ao enviar o Email :(");
                  toast.present();
                }
              } else {
                return false;
              }
            })();
          },
        },
      ],
    });
    alert.present();
  }

  private promptSMS() {
    let alert = this.alertCtrl.create({
      title: "Recibo SMS",
      inputs: [
        {
          name: "celular",
          placeholder: "99 99999 9999",
          value: this.reciclagem.participacao.cliente.celular,
        },
      ],
      buttons: [
        {
          text: "Desistir",
          role: "cancel",
        },
        {
          text: "ENVIAR",
          handler: (data) => {
            (async () => {
              if (data.celular !== "") {
                let load = this.loadCtrl.create({ content: "Enviando SMS..." });
                let mobile = data.celular;
                this.reciclagem.data = new Date();
                try {
                  await this.reciboProvider.enviarSMS(this.reciclagem, mobile);
                  load.dismiss();

                  let toast = this.toastCtrl.create({ duration: 1500 });

                  toast.setMessage("SMS Enviado com Sucesso!");
                  toast.present();
                } catch (error) {
                  load.dismiss();
                  let toast = this.toastCtrl.create({ duration: 1500 });
                  toast.setMessage("Houve um erro ao enviar o SMS :(");
                  toast.present();
                }
              } else {
                return false;
              }
            })();
          },
        },
      ],
    });
    alert.present();
  }

  private getCampanhasAtivas() {
    this.campanhaProvider
      .getAtivasByContrato(this.reciclagem.participacao.contrato)
      .subscribe((retorno: any) => {
        if (retorno !== null) {
          this.showCampanhas = true;
          this.campanhas = retorno;
        }
      });
  }

  private alertInfo(msg: string): void {
    let toast = this.toastCtrl.create({ duration: 2000 });

    toast.setMessage(msg);
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/reciclagem/reciclagem-recibo/reciclagem-recibo.ts